export const LOCATION_TYPE_INDEX = {
  'planet': 2,
  'fleet': 9
};
